import { createHttpClient } from "../httpClient";

// DEV or PROD
const ENV = "PROD";

const URL = {
  PROD: "https://api.apeakclubmc.codx.dev.br/",
  DEV: "http://10.203.0.20:3576/",
};

const apiClient = createHttpClient(URL[ENV]);

export default apiClient;
